import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API_URL } from '../../api/ApiSettings';

const initialState ={
  products: [],
  isLoading: false,
  selectedRow: null,
  tablePage: 1,
  textForSearching: ''
}
export const getProducts = createAsyncThunk(
  'products/getProducts',
  async ({text, complaintType}, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}product?text=${text}&complaintType=${complaintType}`);
      const data = await response.json();
      return data;
    } catch (error) {
      if (error.response) {
        console.log(error);
        if(!error.response) throw error;
        return rejectWithValue(error.response.data);
      }
      throw error;
    }
  }
);
export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProductsSuccess: (state, action) => {
      if (action.payload.response && action.payload.response.products) {
        state.products = action.payload.response.products;
      } else {
        state.products = [];
      }
    },
    
    setSelectedProduct: (state, action) => {
      const productId = action.payload;
      state.selectedRow = state.products.find(product => product.id === productId);

    },
    setComplaintType:(state, action)=>{
      state.complaintType = action.payload;
    },
    setTextForSearching: (state, action) =>{
      state.textForSearching = action.payload;
    },
    setSelectedRow: (state, action) =>{
      state.selectedRow = action.payload;
    },
    clearProducts: (state) =>{
      return initialState;
    }
  },

  extraReducers: {
   
    [getProducts.fulfilled]: (state, action) => {
      state.products = action.payload;
      //state.selectedRow = action.payload[0];
    },
   
  },
});

export const { reset, setComplaintType, setProductsSuccess, setSelectedProduct,selectProduct,setTextForSearching,setSelectedRow,clearProducts } = productsSlice.actions;

export default productsSlice.reducer;